// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4705 ? "dc112a36" : chunkId) + "-" + {"4705":"75d0d71acd6d3366","7882":"69725fd91f3c64a0"}[chunkId] + ".js";
};